<template>
  <div class="student-card-wrap">
    <div class="first-line">
      <span v-if="item.class" :class="`st-type ${item.class}`">{{ item.class === 'red' ? '今' : '近' }}</span>
      <span class="tk-date">
        <i
          class="name-tip-l"
          title="芥末注册用户"
          v-if="item.userid > 0"/>
        <el-tag
          v-for="link in item.link_others"
          :key="link.id"
          type="gray"
        >{{ getSiteTagByType(link.sync_type) }}</el-tag>
        <el-tooltip
          :disabled="!item.crm_memo"
          effect="dark"
          :content="item.crm_memo"
          placement="top-start">
          <router-link
            v-if="!item.is_other"
            target="_blank"
            :to="{ name: 'h5User', params: { crmid: item.id } }"
            state-key="fib.jiemo.net/h5/common/studentCard-昵称"
            :state-status="true">
            <font>{{ item.custom_name }}{{ item.custom_name || item.custom_nickname_tell ? '' : '暂无名称' }}</font>
            <i v-show="item.custom_nickname_tell">|</i>
            <em>{{ item.custom_nickname_tell ? item.custom_nickname_tell : '' }}</em>
          </router-link>
        </el-tooltip>
      </span>
      <span class="sp-right">
        <!-- {{ item.crm_level_lv }} -->
        <jm-dict-select
          type="dataset"
          @change="bindUserStatus"
          v-model="item.crm_level_lv_int"
          dict-type="student"
          :filter="crmLevelFilter"
          name="customLvType"/>
      </span>
      <div class="bottom-text">
        <span>客户编码：{{ item.id }}</span>
        <span class="st-createtime">创建时间：{{ item.create_time }}</span>
      </div>
    </div>
    <div class="chat-wrap">
      <div v-if="item.crm_tel" class="chat-line">
        <img src="../../../assets/wap/icon-backlog-1.png" alt="">
        <span>电话</span>
        <span>{{ item.crm_tel }}</span>
        <Copy :content="item.crm_tel" @copyCallback="copyClick()">
          <el-button>复制</el-button>
        </Copy>
      </div>
      <div v-if="item.crm_weixin" class="chat-line">
        <img src="../../../assets/wap/icon-backlog-2.png" alt="">
        <span>微信</span>
        <span>{{ item.crm_weixin }}</span>
        <Copy :content="item.crm_weixin" @copyCallback="copyClick()">
          <el-button>复制</el-button>
        </Copy>
      </div>
      <div v-if="item.crm_qq" class="chat-line">
        <img src="../../../assets/wap/icon-backlog-3.png" alt="">
        <span>QQ</span>
        <span>{{ item.crm_qq }}</span>
        <Copy :content="item.crm_qq" @copyCallback="copyClick()">
          <el-button>复制</el-button>
        </Copy>
      </div>
    </div>
    <div :class="moreLock ? 'info-wrap active' : 'info-wrap'">
      <div class="info-line">
        <span>渠道</span>
        <div class="channel-area">
          <span v-for="(channel, index) in item.custom_from" :key="index">{{ channel }}<i></i></span>
        </div>
      </div>
      <div class="info-line">
        <span>备注</span>
        <span>{{ item.crm_memo }}</span>
      </div>
      <div v-for="(column, index) in exHeader" :key="index" class="info-line">
        <span>{{ column }}</span>
        <span>{{ item[index] }}</span>
      </div>
      <div class="btn-area">
        <el-button @click="moreClick" class="more-btn">{{ btnText }} <font class="el-icon-arrow-down"></font></el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getSiteTagByType } from '@/utils/utils';

export default {
  props: {
    item: {
      type: Object
    },
    refresh: {
      type: Boolean,
      default: false,
    },
    header: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  mounted() {
    this.fetchData();
    this.initHeader();
  },
  data() {
    return {
      btnText: '查看更多',
      moreLock: false,
      exHeader: {},
      originData: {},
    };
  },
  methods: {
    getSiteTagByType,
    /**
     * 过滤客服分级
     */
    crmLevelFilter(item) {
      if (this.infoReadOnly && !this.isOptManager && !this.isDataAnalyst && this.canEditByCreator && this.originLevel === 64 && [51, 53, 61, 60, 57, 55, 62, 63, 65, 66].indexOf(item.value) > -1) {
        return false;
      }

      if (item.value === 66) {
        return this.$hasPermission(1);
      }
      return true;
    },
    // 复制点击
    copyClick: function() {
      this.$message.success('复制成功');
    },
    // 点击更多
    moreClick: function() {
      this.btnText = this.moreLock ? '查看更多' : '收起内容';
      this.moreLock = !this.moreLock;
    },
    fetchData() {
      this.item.custom_from = typeof this.item.custom_from === 'string' ? this.item.custom_from.split(' ') : this.item.custom_from;
      this.item.crm_id = this.item.crm_id ? this.item.crm_id : this.item.id;
      this.originData = Object.assign({}, this.item);
    },
    initHeader() {
      let list = ['create_time', 'custom_from', 'custom_name', 'id', 'crm_tel', 'crm_weixin', 'crm_qq'];
      let keys = Object.keys(this.header);
      keys.forEach((index) => {
        if (list.indexOf(index) === -1) {
          this.exHeader[index] = typeof (this.header[index]) === 'object' ? this.header[index].label : this.header[index];
        }
      });
    },
    bindUserStatus() {
      this.$confirm('确认修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.item.crm_level_lv = this.item.crm_level_lv_int;
        if (this.item.crm_level_lv === 57) {
          this.item.custom_level = 7;
        }
        if (this.item.crm_level_lv === 65) {
          this.item.custom_level = 9;
        }
        this.$http
          ._post({
            url: '/index/student/save',
            data: {
              id: this.item.id,
              crm_level_lv: this.item.crm_level_lv,
              custom_level: this.item.custom_level,
            }
          })
          .then((data) => {
            if (data.result === 0) {
              // this.$emit('update:refresh', true);
              this.$message({
                type: 'success',
                message: '修改成功!'
              });
            } else {
              this.$message({
                type: 'error',
                message: data.msg
              });
            }
          });
      }).catch(() => {
        this.item.crm_level_lv_int = this.originData.crm_level_lv_int;
        this.$message({
          type: 'info',
          message: '已取消修改'
        });
      });
    },
  }
};
</script>
<style>
  .student-card-wrap .first-line .sp-right .jm-dict-select .el-input__inner{
    border-radius: 0;
    border: none;
    width: 27vw;
    font-size: 3.73vw;
    line-height: 4.2vw;
    height: 4.2vw;
    color: #FF9736;
  }
  .student-card-wrap .first-line .sp-right .jm-dict-select .el-input--medium .el-input__icon{
    line-height: 4.2vw;
  }
</style>
<style scoped>
  .student-card-wrap .first-line{
    line-height: 6vw;
    position: relative;
    font-size: 0;
  }
  .student-card-wrap .first-line > span{
    display: inline-block;
    vertical-align: middle;
  }
  .student-card-wrap .first-line > span.tk-date{
    max-width: 66vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .student-card-wrap .first-line .bottom-text{
    display: flex;
    justify-content: space-between;
    font-size: 3.73vw;
    padding-top: 1.5vw;
    white-space: nowrap;
  }
  .student-card-wrap .first-line .bottom-text > span:last-of-type{
    color: #9a9a9a;
  }
  .student-card-wrap .first-line .st-type{
    width: 4.53vw;
    height: 4.53vw;
    line-height: 4.53vw;
    background: #0496ff;
    color: #fff;
    font-size: 3.73vw;
    border-radius: 0.8vw;
    text-align: center;
    margin-right: 1vw;
  }
  .student-card-wrap .first-line .st-type.red {
    background: #29CB6A;
  }
  .student-card-wrap .first-line .st-type.red1 {
    background: #0496FF;
  }
  .student-card-wrap .first-line .el-tag{
    height: 5vw;
    line-height: 5vw;
    padding: 0 1.5vw;
    margin-right: 1vw;
    display: inline-block;
    vertical-align: middle;
  }
  .student-card-wrap .first-line span a{
    display: inline-block;
    vertical-align: middle;
    font-size: 4vw;
    color: #333;
    line-height: 4vw;
  }
  .student-card-wrap .first-line span a font{
    font-size: 4.8vw;
    font-weight: 600;
    display: inline-block;
    vertical-align: middle;
  }
  .student-card-wrap .first-line span a i{
    display: inline-block;
    vertical-align: middle;
    font-size: 3.4vw;
    padding: 0 2vw;
  }
  .student-card-wrap .first-line span a em{
    display: inline-block;
    vertical-align: middle;
  }
  .student-card-wrap .first-line .sp-right{
    position: absolute;
    right: 0;
    top: 0;
    color: #FF9736;
    font-size: 3.73vw;
    padding-bottom: 1vw;
  }
  .student-card-wrap .chat-wrap{
    background: #fff;
    border-radius: 2vw;
    box-shadow: 0px 0px 1.8vw rgba(150, 179, 236, 0.3);
    margin-top: 3.5vw;
    padding: 1vw 4vw;
  }
  .student-card-wrap .chat-wrap .chat-line{
    position: relative;
    width: 71.73vw;
    margin-left: 8vw;
    border-bottom: 0.5px dashed #d1d2f2;
    line-height: 11.73vw;
  }
  .student-card-wrap .chat-wrap .chat-line:last-of-type{
    border: none;
  }
  .student-card-wrap .chat-wrap .chat-line img{
    position: absolute;
    left: -8vw;
    width: 5vw;
    top: 50%;
    transform: translateY(-50%);
  }
  .student-card-wrap .chat-wrap .chat-line span{
    font-size: 4vw;
    color: #474859;
  }
  .student-card-wrap .chat-wrap .chat-line span:first-of-type{
    color: #9AA1BA;
    display: inline-block;
    width: 11.4vw;
  }
  .student-card-wrap .chat-wrap .chat-line .copy{
    float: right;
  }
  .student-card-wrap .chat-wrap .chat-line .el-button{
    padding: 0;
    background: none;
    height: 4.8vw;
    line-height: 4.8vw;
    border: 1px solid #0496ff;
    color: #0496ff;
    border-radius: 2.4vw;
    padding: 0 2.5vw;
    font-size: 3.46vw;
  }
  .student-card-wrap .info-wrap{
    padding: 4.5vw 0 9vw;
    height: 35vw;
    overflow: hidden;
    position: relative;
    font-size: 3.73vw;
  }
  .student-card-wrap .info-wrap.active{
    height: auto;
  }
  .student-card-wrap .info-wrap .btn-area{
    display: block;
    text-align: center;
    width: 100%;
    background: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .student-card-wrap .info-wrap .more-btn{
    padding: 0;
    border: none;
    color: #0496ff;
    font-size: 3.73vw;
    line-height: 6vw;
    background: #fff;
    padding-left: 3vw;
  }
  .student-card-wrap .info-wrap .more-btn font{
    display: inline-block;
  }
  .student-card-wrap .info-wrap.active .more-btn font{
    transform: rotate(180deg);
  }
  .student-card-wrap .info-wrap .info-line{
    display: flex;
    justify-content: space-between;
    border-bottom: 0.7px dashed #dfdfdf;
    align-items: center;
  }
  .student-card-wrap .info-wrap .info-line > span{
    font-size: 4vw;
    line-height: 5vw;
  }
  .student-card-wrap .info-wrap .info-line > span:first-of-type{
    color: #9aa1ba;
    white-space: nowrap;
    margin-right: 3vw;
    line-height: 11vw;
  }
  .student-card-wrap .info-wrap .info-line .channel-area{
    line-height: 5vw;
  }
  .student-card-wrap .info-wrap .info-line .channel-area span{
    display: inline-block;
    position: relative;
    color: #333;
  }
  .student-card-wrap .info-wrap .info-line .channel-area span i{
    display: inline-block;
    margin: 0 1.2vw;
    border-left: 1.5vw solid #0496ff;
    border-top: 1vw solid transparent;
    border-bottom: 1vw solid transparent;
  }
  .student-card-wrap .info-wrap .info-line .channel-area span:last-of-type i{
    display: none;
  }
  .student-card-wrap .name-tip-l{
    vertical-align: middle;
    margin-top: 0;
    width: 1.3vw;
    height: 4vw;
    border-radius: 0.5vw;
    margin-right: 1.4vw;
    background-color: #0496ff;
  }
</style>
